import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeForm = _resolveComponent("WelcomeForm")!
  const _component_ResultsForm = _resolveComponent("ResultsForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.message), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.search_data && _ctx.hotels === null)
      ? (_openBlock(), _createBlock(_component_WelcomeForm, {
          key: 1,
          onSubmit: _ctx.onFormSubmit
        }, null, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.search_data)
      ? (_openBlock(), _createBlock(_component_ResultsForm, {
          key: 2,
          search_data: _ctx.search_data,
          ref: "result_form"
        }, null, 8, ["search_data"]))
      : _createCommentVNode("", true)
  ]))
}